import { filter } from 'lodash';

const anonymous = [
  {
    name: 'Login',
    view: 'Login',
    text: 'Menu.login',
    path: '/login',
    icon: 'mdi-account',
  },
  {
    path: '/account/forgot-password',
    name: 'Password Reset',
    view: 'ForgotPassword',
  },
  {
    path: '/account/reset-password',
    name: 'ResetPassword',
    view: 'ResetPassword',
  },
];
const anonymousMenu = filter(anonymous, a => a.icon);

const authenticated = [
  {
    path: '/dashboard',
    icon: 'mdi-view-dashboard',
    text: 'Menu.dashboard',
    view: 'Dashboard',
    meta: { auth: true, roles: ['Administrators'] },
  },
  {
    path: '/assessments',
    icon: 'mdi-check',
    text: 'Menu.assessment',
    view: 'Assessments',
    meta: { auth: true, roles: ['Administrators'] },
  },
  {
    path: '/assessment',
    name: 'Create Assessment',
    view: 'Assessment',
    meta: { auth: true, roles: ['Administrators'] },
  },
  {
    path: '/assessment/:id',
    name: 'Edit Assessment',
    view: 'AssessmentEdit',
    meta: { auth: true, roles: ['Administrators'] },
  },
  {
    path: '/assessmentItems',
    name: 'Assessment Items',
    view: 'AssessmentItems',
    meta: { auth: true, roles: ['Administrators'] },
  },
  {
    path: '/clients',
    icon: 'mdi-account',
    text: 'Menu.clients',
    view: 'Clients',
    meta: { auth: true, roles: ['Administrators'] },
  },
  {
    path: '/reports',
    icon: 'mdi-finance',
    text: 'Menu.reports',
    view: 'Reports/Index',
    meta: { auth: true, roles: ['Administrators'] },
  },
  {
    path: '/admin/tabs',
    icon: 'mdi-tab',
    text: 'Menu.tabs',
    view: 'Admin/Tabs',
    name: 'Tabs',
    meta: { auth: true, roles: ['Administrators'] },
  },
  {
    path: '/admin/metrics',
    icon: 'mdi-tune',
    text: 'Menu.metrics',
    view: 'Admin/Metrics',
    name: 'Metrics',
    meta: { auth: true, roles: ['Administrators'] },
  },
  {
    path: '/reports',
    name: 'Reports',
    view: 'Index',
    meta: { auth: true, roles: ['Administrators'] },
  },
  {
    path: '/reports/progress',
    name: 'Progress Report',
    view: 'Reports/Progress',
    meta: { auth: true, roles: ['Administrators'] },
  },
  {
    path: '/reports/standardsMeasure',
    name: 'SAMM Model Report',
    view: 'Reports/StandardsMeasure',
    meta: { auth: true, roles: ['Administrators'] },
  },
];

const authenticatedMenu = filter(authenticated, a => a.icon);

const appRedirects = [
  {
    path: '*',
    redirect: '/dashboard',
  },
  {
    path: '/',
    redirect: '/dashboard',
  },
];

const appRoutes = [...anonymous, ...authenticated];

export { anonymousMenu };
export { authenticatedMenu };

export { appRoutes };
export { appRedirects };

export default {};
